import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

import RouteWithSubRoutes from 'components/global/RouteWithSubRoutes';

import routes from 'routes';

import './styles/styles.scss';

function App() {
  return (
    <Router>
      <Switch>
        {routes.map((route) => (
          <RouteWithSubRoutes key={uuid()} {...route} />
        ))}
      </Switch>
    </Router>
  );
}

export default App;
